import Configs from '../../../../src/vendorConfigs/Configs';
import { Tween } from '../../Tween';
import GameModel from '../../model/GameModel';
import SpinModel from '../../model/SpinModel';
import { DefaultLayers } from '../../utils/Layers';
import ViewManager from '../../utils/ViewManager'
import CascadeReelGroup from '../../views/CascadeReelGroup';
import { State } from '../State';

export default class CascadeFillRemainingState extends State {
    protected reelGroup: CascadeReelGroup;
    /**
     * Value must be in ms
     */
    protected delayToExit: number = 50;
    public enter(): void {
        super.enter();
        this.init();
    }
    /**
     * Put here all logic called after enter of the state
     */
    protected init(): void {
        this.reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
            .getCurrentScene()
            .getSubView("ReelGroup") as CascadeReelGroup;

        this.fillRemaining()
        // // Set up delay to exit
        this.setExitDelayTween();
    }
    /**
     * Set up a delay call tween for exit of this state
     */
    protected setExitDelayTween(): void {
        Tween.delayedCall(this.getStateDuration(), () => this.exit())
    }

    /**
     * @returns Duration time in this state in seconds (1000ms = 1s)
     */
    protected getStateDuration(): number {
        return (this.getExitDelay() + this.getRemainingSymbolsDroppedAnimationDuration()) / 1000
    }
    /**
     * @returns Delay for exit of the state after animations complete in seconds (1000ms = 1s)
     */
    protected getExitDelay(): number {
        return this.delayToExit
    }
    /**
     * @returns Duration time needed to fill all missing symbols in ms (1000ms = 1s)
     */
    protected getRemainingSymbolsDroppedAnimationDuration(): number {
        let result = 0;
        let delayBetweenReels = 0;
        let delayBetweenSymbols = 0;
        let animDuration = 0;
        let numberOfEmptyPlaces = SpinModel.cascades[SpinModel.cascadeIndex - 1]?.winsData.reduce((acc, d) => {
            if (d.coordinates) {
                acc += d.coordinates.length;
            }
            return acc
        }, 0);

        if (Configs.reels) {
            if (GameModel.turboSpin) {
                delayBetweenReels = Configs.reels.numberOfReels * Configs.reels.cascadeProps.fillRemainingProps.reelDelayInTurboMode;
                animDuration = Configs.reels.cascadeProps.fillRemainingProps.animTimeInTurbo;
                delayBetweenSymbols = Configs.reels.cascadeProps.fillRemainingProps.symbolDelayInTurboMode * numberOfEmptyPlaces;
            } else {
                animDuration = Configs.reels.cascadeProps.fillRemainingProps.animTime;
                delayBetweenReels = Configs.reels.numberOfReels * Configs.reels.cascadeProps.fillRemainingProps.reelDelay;
                delayBetweenSymbols = Configs.reels.cascadeProps.fillRemainingProps.symbolDelay * numberOfEmptyPlaces;
            }
        }


        result += animDuration + delayBetweenReels + delayBetweenSymbols;

        return result
    }

    protected fillRemaining(delay = 0) {
        this.reelGroup.cascadeFillRemaining(delay);
    }
}
